module.exports = __webpack_public_path__ + "d7c18a61b2e833b18040bc6a283d7fa6.svg";